import Api from '#services/api'

export async function useAzubisWithWissensportal() {
  const azubisWithWissensportal = await Api.getAzubisWithWissensportalModul()
  return azubisWithWissensportal ? azubisWithWissensportal : []
}
